require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setSuggestionsSearchValue = setSuggestionsSearchValue;
exports.clearSuggestionsSearchValue = clearSuggestionsSearchValue;
exports.updateAnalyticsConfig = updateAnalyticsConfig;
exports.recordResultClick = recordResultClick;
exports.recordSuggestionClick = recordSuggestionClick;

var _constants = require('../constants');

function setSuggestionsSearchValue(value) {
  return {
    type: _constants.SET_SUGGESTIONS_SEARCH_VALUE,
    value: value
  };
}

function clearSuggestionsSearchValue() {
  return {
    type: _constants.CLEAR_SUGGESTIONS_SEARCH_VALUE
  };
}

function updateAnalyticsConfig(analyticsConfig) {
  return {
    type: _constants.UPDATE_ANALYTICS_CONFIG,
    analyticsConfig: analyticsConfig
  };
}

function recordResultClick(searchPosition) {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config,
        searchId = _getState.analytics.searchId,
        headers = _getState.headers;

    var url = config.url,
        app = config.app,
        credentials = config.credentials;

    if (config.analytics && searchId) {
      var parsedHeaders = headers;
      delete parsedHeaders['X-Search-Query'];
      fetch(url + '/' + app + '/_analytics', {
        method: 'POST',
        headers: _extends({}, parsedHeaders, {
          'Content-Type': 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
          'X-Search-Id': searchId,
          'X-Search-Click': true,
          'X-Search-ClickPosition': searchPosition + 1
        })
      });
    }
  };
}

function recordSuggestionClick(searchPosition) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        config = _getState2.config,
        suggestionsSearchId = _getState2.analytics.suggestionsSearchId,
        headers = _getState2.headers;

    var url = config.url,
        app = config.app,
        credentials = config.credentials;

    if (config.analytics && suggestionsSearchId) {
      var parsedHeaders = headers;
      delete parsedHeaders['X-Search-Query'];
      fetch(url + '/' + app + '/_analytics', {
        method: 'POST',
        headers: _extends({}, parsedHeaders, {
          'Content-Type': 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
          'X-Search-Id': suggestionsSearchId,
          'X-Search-Suggestions-Click': true
        }, searchPosition !== undefined && {
          'X-Search-Suggestions-ClickPosition': searchPosition + 1
        })
      });
    }
  };
}